const full_name_config = {
  label: "Full Name / ಹೆಸರು",
  type: "text",
  name: "name",
  id: "name",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};
const full_name_config_hindi = {
  label: "Full Name/पूरा नाम:",
  type: "text",
  name: "name",
  id: "name",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};

const fathers_name_config = {
  label: "Fathers Name/पिताजी का नाम:",
  type: "text",
  name: "fathers_name",
  id: "fathers_name",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};

const perm_address_config = {
  label: "Permanent Address/स्थायी पता:",
  type: "text",
  name: "perm_address",
  id: "perm_address",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};

const curr_address_config = {
  label: "Current Address/वर्त्तमान पता",
  type: "text",
  name: "curr_address",
  id: "curr_address",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};

const dob_config = {
  label: "What is your Date of Birth (DoB)? / ⁠ಹುಟ್ಟಿದ ದಿನಾಂಕ",
  type: "date",
  name: "date_of_birth",
  id: "date_of_birth",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};

const loan_amount_config = {
  label: "Loan Amount(In Rupees)/लोन रकम(रुपये में):",
  type: "number",
  name: "loan_amount",
  id: "loan_amount",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    min: 0,
  },
  page: "loan-details",
  inputInfoText: "Please note we can only provide loans up to loan_amount",
};
const deposit_amount_config = {
  label: "Deposit Amount(In Rupees)/जमा राशि (रुपये में)):",
  type: "number",
  name: "deposit_amount",
  id: "deposit_amount",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    min: 0,
  },
  page: "personal-details",
  inputInfoText: "Please mention the deposit required",
};
const loan_duration_config = {
  label: "Loan Duration(in Months)/लोन अवधि(महीनों में):",
  type: "number",
  name: "loan_period",
  id: "loan_period",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    min: 0,
    max: 10,
  },
  page: "loan-details",
  inputInfoText: "Limit of tenure is 10 months only",
};
const terms_conditions_config = {
  label: "",
  type: "textarea",
  name: "terms_conditions",
  id: "terms_conditions",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "terms-details",
};
const gender_config = {
  label: "Gender / ಲಿಂಗ",
  type: "select",
  name: "gender",
  id: "gender",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  placeholder: "Please select a gender",
  options: [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
  ],
  page: "personal-details",
};

const repayment_config = {
  label: "loan repayment frequency/ऋण चुकौती आवृत्ति:",
  type: "select",
  name: "repayment_frequency",
  id: "repayment_frequency",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  placeholder: "Please select your preferred repayment frequency",
  options: [
    { value: "Weekly", label: "Weekly" },
    { value: "Monthly", label: "Monthly" },
  ],
  page: "loan-details",
};

const marital_status_config = {
  label: "Marital Status / ವೈವಾಹಿಕ ಸ್ಥಿತಿ",
  type: "select",
  name: "marital_status",
  id: "marital_status",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  placeholder: "Please select a marital status",
  options: [
    { value: "Single", label: "Single" },
    { value: "Married", label: "Married" },
    { value: "Divorced", label: "Divorced" },
  ],
  page: "personal-details",
};
const pan_card_config = {
  label: "PAN Card Number/पैन कार्ड नंबर:",
  type: "text",
  name: "pan_card",
  id: "pan_card",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    pattern: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
  },
  page: "personal-details",
};
const city_config = {
  label: "City/शहर",
  type: "text",
  name: "city",
  id: "city",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};
const salary_inhand_config = {
  label: "In-hand monthly salary(In Rupees)/मासिक वेतन(रुपये में):",
  type: "number",
  name: "salary_inhand",
  id: "salary_inhand",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    min: 0,
  },
  page: "personal-details",
};
const date_of_joining_config = {
  label: "What is your Date of Joining (DoJ)/कार्यग्रहण तारीख?:",
  type: "date",
  name: "date_of_joining",
  id: "date_of_joining",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};
const company_name_config = {
  label: "Company Name/कंपनी का नाम",
  type: "select",
  name: "company_name",
  id: "company_name",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  placeholder: "Please select a company name",
  options: [],
  page: "personal-details",
};
const company_employee_id_config = {
  label: "Employee Id/ कर्मचारी ID",
  type: "text",
  name: "company_employee_id",
  id: "company_employee_id",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};
const designation_config = {
  label: "Designation/ उपाधि",
  type: "text",
  name: "designation",
  id: "designation",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};
const bank_account_no_config = {
  label: "Bank Account No./ बैंक खाता क्रमांक",
  type: "text",
  name: "account_no",
  id: "account_no",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};

const perm_address_pincode_config = {
  label: "Permanent Pincode/ स्थायी पिनकोड",
  type: "text",
  name: "perm_address_pincode",
  id: "perm_address_pincode",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};

const curr_address_pincode_config = {
  label: "Current Pincode/ वर्तमान पिनकोड",
  type: "text",
  name: "curr_address_pincode",
  id: "curr_address_pincode",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};
const ifsc_config = {
  label: "IFSC Code/ आईएफएससी कोड(भारतीय वित्तीय प्रणाली कोड)",
  type: "text",
  name: "ifsc_code",
  id: "ifsc_code",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    pattern: {
      value: /^[A-Za-z]{4}[a-zA-Z0-9]{7}$/,
      message: "Invalid IFSC code format"
    }
  },
  page: "personal-details",
};
const mobile_number_config = {
  label: "Enter mobile number",
  type: "number",
  name: "mobile_number",
  id: "mobile_number",
  validation: {
    required: {
      value: true,
      message: "Mobile number is required",
    },
    maxLength: {
      value: 10,
      message: "Mobile number should be 10 digit",
    },
    minLength: {
      value: 10,
      message: "Mobile number should be 10 digit",
    },
  },
  page: "personal-details",
  inputInfoText:
    "After submission, we will be sending status updates on your whatsapp number",
};
const aadhaar_mobile_number_config = {
  label: "Mobile number linked with Aadhaar Card / ಆಧಾರ್ ಲಿಂಕ್ ಮಾಡಲಾದ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
  type: "number",
  name: "mobile_number_aadhaar",
  id: "mobile_number_aadhaar",
  validation: {
    required: {
      value: true,
      message: "Mobile number is required",
    },
    maxLength: {
      value: 10,
      message: "Mobile number should be 10 digit",
    },
    minLength: {
      value: 10,
      message: "Mobile number should be 10 digit",
    },
  },
  page: "personal-details",
  // inputInfoText:
  //   "After submission, we will be sending status updates on your whatsapp number",
};
const aadhaar_mobile_number_config_hindi = {
  label: "Enter mobile number linked with Aadhaar Card",
  type: "number",
  name: "mobile_number_aadhaar",
  id: "mobile_number_aadhaar",
  validation: {
    required: {
      value: true,
      message: "Mobile number is required",
    },
    maxLength: {
      value: 10,
      message: "Mobile number should be 10 digit",
    },
    minLength: {
      value: 10,
      message: "Mobile number should be 10 digit",
    },
  },
  page: "personal-details",
  // inputInfoText:
  //   "After submission, we will be sending status updates on your whatsapp number",
};

const adhaar_card_config = {
  label: "Aadhar Card Number/आधार कार्ड नंबर:",
  type: "text",
  name: "aadhaar",
  id: "aadhaar",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    pattern: /^\d{12}$/,
  },
  page: "personal-details",
};

export const formFields = {
  quess: [
    full_name_config,
    salary_inhand_config,
    date_of_joining_config,
    dob_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <p>By applying for a personal loan with Financing Partner, I read, understood and willing to obtain a personal loan on the terms and conditions of the Financing Partner documents, subject to my eligibility criteria and fulfilling necessary documentation process with Financing Partner. I accept the terms and conditions and request Financing Partner to disburse the personal loan amount to me on the said terms. I hereby, declare that, the entries made by me in the Application Form are complete and true to the best of my knowledge and based on records. I, hereby, undertake to present the original documents immediately upon demand by the concerned authorities of the Financing Partner. I, hereby undertake to inform the Financing Partner & Company/my current employer, about any changes in information submitted by me, in the Application Form and any other documents, including change in addresses and phone nos., from time to time. I, hereby authorise, explicitly consent to Company to validate and provide the information sought by the Financing Partner regarding my employment and payroll including salary & deductions related details. I also expressly agree and undertake to repay my loan outstanding through EMI mode, as specified in the loan agreement. i.e., the subsequent EMIs (along with interest payments, including revised interest rates / delayed charges, if applicable) henceforth. I further given my consent and hereby authorize Quess Corp Ltd and/or any of its group companies, where I am employed as on date (“Current Employer”) to deduct the EMI amount as specified by me from my monthly salary payout, which will be paid to the Financing Partner by Quess Corp Ltd and/or any of its group companies, till the time I am employed with the Current Employer or loan closure confirmation from me to the Current Employer, whichever is earlier, subject to applicable deductions and policies from time to time. I agree that personal loan repayment or EMI payment is always my responsibility and liability to repay all outstanding amounts to the Financing Partner on or within the stipulated dates, and Quess Corp Ltd and/or any of its group companies is not be made responsible / liable for any outstanding dues or any non-payment or any other charges payable by me to the Financing Partner, in case there is a delay or default in my loan repayment at any point of time. I further declare and undertake, that if at any stage, my employment with Company can be terminated /comes to an end, and loan will be refunded by me to Financing Partner directly. I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy. </p>",
    },
  ],
  swiggy: [
    full_name_config,
    {
      ...company_employee_id_config,
      label: "Swiggy DE ID number/स्विगी आईडी नंबर:",
    },
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    gender_config,
    marital_status_config,
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <li>On installing the Swiggy application, providing my requisite details to Swiggy, receiving a unique login ID and password, and agreeing to the terms of the Agreement for pick up and delivery partner, I had consented to provide services as a Pick-Up and Delivery Partner (“PDP”) to customers or merchants  on the Swiggy platform (i.e website or mobile application operated by Swiggy).</li>  <li> I am willing to participate in the ‘Loan Program’ being provided by Entitled Solutions Private Limited (‘Entitled’) through their NBFC partners..</li>  <li> For the aforesaid purpose, I authorize Swiggy to share the following personal information with NBFC and Entitled: my name, phone number, address, date of engagement with Swiggy, my ratings, my engagement status (active/inactive), bank account details, my gross earnings.</li> <li> I am agreeing that the instalments of the loan successfully disbursed to me will be deducted from my payout by Swiggy and transferred to Entitled or it's NBFC partners.</li> <li> I understand and agree that Swiggy will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to the loans availed by me.</li>    <li> I am agreeing to these terms and opting for the Loan Program voluntarily, by my own free will and volition. </li> <li> I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. </li> <li> I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy. </li> ",
    },
  ],
  entitled: [
    full_name_config,
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    gender_config,
    marital_status_config,
    {
      ...company_name_config,
      options: [
        { value: "WIFY", label: "WIFY" },
        { value: "Pecopp", label: "Pecopp" },
        { value: "Viridian", label: "Viridian" },
        { value: "Care24", label: "Care24" },
        { value: "XYXX", label: "XYXX" },
        { value: "Others", label: "Others" },
      ],
    },
    {
      ...company_employee_id_config,
      label: "Employee Id Number",
    },
    city_config,
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <ol><li> I have been engaged with the “Company” as a full-time or contractual “Employee” or as an independent service provider as a “Gig Worker”.</li> <li> The “Company” has tied up with “Entitled Solutions Pvt Ltd” (hereinafter referred to as “Entitled”) to enable access to a “Loan Program”.</li> <li> “Entitled” is a benefits solution that enables access to loans (besides other services) for workers. It works with RBI registered NBFCs to process such loans for workers.</li> <li>I hereby confirm that I am willing to participate in the ‘Loan Program’ being provided by “Entitled”.</li><li> For the aforesaid purpose, I authorise the “Company” to deduct the instalments payable by me to “Entitled” for availing the loan facility provided by “Entitled”, from my pay-outs and remit the same to “Entitled” on my behalf.</li><li>I also authorise “Entitled” to charge instalments payable by me to “Entitled” for availing the loan facility provided by “Entitled”, to my bank account to which the “Company” deposits the salary or payout on a monthly or weekly basis via eNACH.</li><li> In addition to the same, I authorize the “Company” to share my personal information with “Entitled” including but not limited to my name, phone number, address, date of engagement with the “Company”, my status (active/inactive), bank account details, my gross earnings etc</li><li>I understand and agree that the “Company” will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to the loan availed by me.</li><li> I understand and agree that the “Company” will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to deductions from my payouts.</li>  <li> I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. </li> <li> I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy. </li> </ol>",
    },
  ],
  letstransport: [
    full_name_config,
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 100000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "1,00,000"
      ),
    },
    loan_duration_config,
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <p>By applying for a personal loan with Financing Partner, I read, understood and willing to obtain a personal loan on the terms and conditions of the Financing Partner documents, subject to my eligibility criteria and fulfilling necessary documentation process with Financing Partner. I accept the terms and conditions and request Financing Partner to disburse the personal loan amount to me on the said terms. I hereby, declare that, the entries made by me in the Application Form are complete and true to the best of my knowledge and based on records. I, hereby, undertake to present the original documents immediately upon demand by the concerned authorities of the Financing Partner. I, hereby undertake to inform the Financing Partner & Company/my current employer, about any changes in information submitted by me, in the Application Form and any other documents, including change in addresses and phone nos., from time to time. I, hereby authorise, explicitly consent to Company to validate and provide the information sought by the Financing Partner regarding my employment and payroll including salary & deductions related details. I also expressly agree and undertake to repay my loan outstanding through EMI mode, as specified in the loan agreement. i.e., the subsequent EMIs (along with interest payments, including revised interest rates / delayed charges, if applicable) henceforth. I further given my consent and hereby authorize  and/or any of its group companies, where I am employed as on date (“Current Employer”) to deduct the EMI amount as specified by me from my monthly salary payout, which will be paid to the Financing Partner by LetsTransport Ltd and/or any of its group companies, till the time I am employed with the Current Employer or loan closure confirmation from me to the Current Employer, whichever is earlier, subject to applicable deductions and policies from time to time. I agree that personal loan repayment or EMI payment is always my responsibility and liability to repay all outstanding amounts to the Financing Partner on or within the stipulated dates, and LetsTransport Ltd and/or any of its group companies is not be made responsible / liable for any outstanding dues or any non-payment or any other charges payable by me to the Financing Partner, in case there is a delay or default in my loan repayment at any point of time. I further declare and undertake, that if at any stage, my employment with Company can be terminated /comes to an end, and loan will be refunded by me to Financing Partner directly. I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy. </p>",
    },
  ],
  MarapurandJamindarguriTeaEstate: [
    full_name_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <p>By applying for a personal loan with Financing Partner, I read, understood and willing to obtain a personal loan on the terms and conditions of the Financing Partner documents, subject to my eligibility criteria and fulfilling necessary documentation process with Financing Partner. I accept the terms and conditions and request Financing Partner to disburse the personal loan amount to me on the said terms. I hereby, declare that, the entries made by me in the Application Form are complete and true to the best of my knowledge and based on records. I, hereby, undertake to present the original documents immediately upon demand by the concerned authorities of the Financing Partner. I, hereby undertake to inform the Financing Partner & Company/my current employer, about any changes in information submitted by me, in the Application Form and any other documents, including change in addresses and phone nos., from time to time. I, hereby authorise, explicitly consent to Company to validate and provide the information sought by the Financing Partner regarding my employment and payroll including salary & deductions related details. I also expressly agree and undertake to repay my loan outstanding through EMI mode, as specified in the loan agreement. i.e., the subsequent EMIs (along with interest payments, including revised interest rates / delayed charges, if applicable) henceforth. I further given my consent and hereby authorize  and/or any of its group companies, where I am employed as on date (“Current Employer”) to deduct the EMI amount as specified by me from my monthly salary payout, which will be paid to the Financing Partner by and/or any of its group companies, till the time I am employed with the Current Employer or loan closure confirmation from me to the Current Employer, whichever is earlier, subject to applicable deductions and policies from time to time. I agree that personal loan repayment or EMI payment is always my responsibility and liability to repay all outstanding amounts to the Financing Partner on or within the stipulated dates, and  and/or any of its group companies is not be made responsible / liable for any outstanding dues or any non-payment or any other charges payable by me to the Financing Partner, in case there is a delay or default in my loan repayment at any point of time. I further declare and undertake, that if at any stage, my employment with Company can be terminated /comes to an end, and loan will be refunded by me to Financing Partner directly.</p>",
    },
  ],
  enableCap: [
    full_name_config,
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 100000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "1,00,000"
      ),
    },
    loan_duration_config,
    gender_config,
    marital_status_config,
    {
      ...company_name_config,
      options: [
        {
          value: "The Maintenance Wallas",
          label: "The Maintenance Wallas",
        },
        {
          value: "Kolkata Response Group Pvt Ltd",
          label: "Kolkata Response Group Pvt Ltd",
        },
      ],
    },
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <ol><li> I have been engaged with the “Company” as a full-time or contractual “Employee” or as an independent service provider as a “Gig Worker”.</li> <li> The “Company” has tied up with “Entitled Solutions Pvt Ltd” (hereinafter referred to as “Entitled”) to enable access to a “Loan Program”.</li> <li> “Entitled” is a benefits solution that enables access to loans (besides other services) for workers. It works with RBI registered NBFCs to process such loans for workers.</li> <li>I hereby confirm that I am willing to participate in the ‘Loan Program’ being provided by “Entitled”.</li><li> For the aforesaid purpose, I authorise the “Company” to deduct the instalments payable by me to “Entitled” for availing the loan facility provided by “Entitled”, from my pay-outs and remit the same to “Entitled” on my behalf.</li><li>I also authorise “Entitled” to charge instalments payable by me to “Entitled” for availing the loan facility provided by “Entitled”, to my bank account to which the “Company” deposits the salary or payout on a monthly or weekly basis via eNACH.</li><li> In addition to the same, I authorize the “Company” to share my personal information with “Entitled” including but not limited to my name, phone number, address, date of engagement with the “Company”, my status (active/inactive), bank account details, my gross earnings etc</li><li>I understand and agree that the “Company” will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to the loan availed by me.</li><li> I understand and agree that the “Company” will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to deductions from my payouts.</li>  <li> I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. </li> <li> I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy. </li> </ol>",
    },
  ],
  mobiGarage: [
    full_name_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 100000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "1,00,000"
      ),
    },
    loan_duration_config,
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <p>By applying for a personal loan with Financing Partner, I read, understood and willing to obtain a personal loan on the terms and conditions of the Financing Partner documents, subject to my eligibility criteria and fulfilling necessary documentation process with Financing Partner. I accept the terms and conditions and request Financing Partner to disburse the personal loan amount to me on the said terms. I hereby, declare that, the entries made by me in the Application Form are complete and true to the best of my knowledge and based on records. I, hereby, undertake to present the original documents immediately upon demand by the concerned authorities of the Financing Partner. I, hereby undertake to inform the Financing Partner & Company/my current employer, about any changes in information submitted by me, in the Application Form and any other documents, including change in addresses and phone nos., from time to time. I, hereby authorise, explicitly consent to Company to validate and provide the information sought by the Financing Partner regarding my employment and payroll including salary & deductions related details. I also expressly agree and undertake to repay my loan outstanding through EMI mode, as specified in the loan agreement. i.e., the subsequent EMIs (along with interest payments, including revised interest rates / delayed charges, if applicable) henceforth. I further given my consent and hereby authorize  and/or any of its group companies, where I am employed as on date (“Current Employer”) to deduct the EMI amount as specified by me from my monthly salary payout, which will be paid to the Financing Partner by MobiGarage Ltd and/or any of its group companies, till the time I am employed with the Current Employer or loan closure confirmation from me to the Current Employer, whichever is earlier, subject to applicable deductions and policies from time to time. I agree that personal loan repayment or EMI payment is always my responsibility and liability to repay all outstanding amounts to the Financing Partner on or within the stipulated dates, and mobiGarage Ltd and/or any of its group companies is not be made responsible / liable for any outstanding dues or any non-payment or any other charges payable by me to the Financing Partner, in case there is a delay or default in my loan repayment at any point of time. I further declare and undertake, that if at any stage, my employment with Company can be terminated /comes to an end, and loan will be refunded by me to Financing Partner directly.</p>",
    },
  ],
  pecopp: [
    full_name_config,
    {
      ...company_employee_id_config,
      label: "Pecopp ID number/पकप्प आईडी नंबर:",
    },
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    gender_config,
    marital_status_config,
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <li> I am willing to participate in the ‘Loan Program’ being provided by Entitled Solutions Private Limited (‘Entitled’) through their NBFC partners..</li>  <li> For the aforesaid purpose, I authorize Pecopp to share the following personal information with NBFC and Entitled: my name, phone number, address, date of engagement with Pecopp, my ratings, my engagement status (active/inactive), bank account details, my gross earnings.</li> <li> I am agreeing that the instalments of the loan successfully disbursed to me will be deducted from my bank account by Entitled or it's NBFC partners.</li> <li> I understand and agree that Pecopp will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to the loans availed by me.</li>    <li> I am agreeing to these terms and opting for the Loan Program voluntarily, by my own free will and volition. </li> <li> I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. </li> <li> I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy. </li> ",
    },
  ],
  wify: [
    full_name_config,
    {
      ...company_employee_id_config,
      label: "Wify Employee ID /Wify कर्मचारी आईडी",
    },
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    gender_config,
    marital_status_config,
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <li>On installing the Wify application, providing my requisite details to Wify, receiving a unique login ID and password, and agreeing to the terms of the Agreement for pick up and delivery partner, I had consented to provide services as a Pick-Up and Delivery Partner (“PDP”) to customers or merchants  on the Wify platform (i.e website or mobile application operated by Wify).</li>  <li> I am willing to participate in the ‘Loan Program’ being provided by Entitled Solutions Private Limited (‘Entitled’) through their NBFC partners..</li>  <li> For the aforesaid purpose, I authorize Wify to share the following personal information with NBFC and Entitled: my name, phone number, address, date of engagement with Wify, my ratings, my engagement status (active/inactive), bank account details, my gross earnings.</li> <li> I am agreeing that the instalments of the loan successfully disbursed to me will be deducted from my payout by Wify and transferred to Entitled or it's NBFC partners.</li> <li> I understand and agree that Wify will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to the loans availed by me.</li>    <li> I am agreeing to these terms and opting for the Loan Program voluntarily, by my own free will and volition. </li> <li> I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. </li> <li> I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy. </li> ",
    },
  ],
  myMobiForce: [
    full_name_config,
    {
      ...company_employee_id_config,
      label: "MyMobiforce  ID number/पकप्प आईडी नंबर:",
    },
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    gender_config,
    marital_status_config,
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <li> I am willing to participate in the ‘Loan Program’ being provided by Entitled Solutions Private Limited (‘Entitled’) through their NBFC partners..</li>  <li> For the aforesaid purpose, I authorize myMobiForce to share the following personal information with NBFC and Entitled: my name, phone number, address, date of engagement with myMobiForce, my ratings, my engagement status (active/inactive), bank account details, my gross earnings.</li> <li> I am agreeing that the instalments of the loan successfully disbursed to me will be deducted from my bank account by Entitled or it's NBFC partners.</li> <li> I understand and agree that myMobiForce will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to the loans availed by me.</li>    <li> I am agreeing to these terms and opting for the Loan Program voluntarily, by my own free will and volition. </li> <li> I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. </li> <li> I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy. </li> ",
    },
  ],
  zypp: [
    full_name_config,
    dob_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <p>By applying for a personal loan with Financing Partner, I read, understood and willing to obtain a personal loan on the terms and conditions of the Financing Partner documents, subject to my eligibility criteria and fulfilling necessary documentation process with Financing Partner. I accept the terms and conditions and request Financing Partner to disburse the personal loan amount to me on the said terms. I hereby, declare that, the entries made by me in the Application Form are complete and true to the best of my knowledge and based on records. I, hereby, undertake to present the original documents immediately upon demand by the concerned authorities of the Financing Partner. I, hereby undertake to inform the Financing Partner & Company/my current employer, about any changes in information submitted by me, in the Application Form and any other documents, including change in addresses and phone nos., from time to time. I, hereby authorise, explicitly consent to Company to validate and provide the information sought by the Financing Partner regarding my employment and payroll including salary & deductions related details. I also expressly agree and undertake to repay my loan outstanding through EMI mode, as specified in the loan agreement. i.e., the subsequent EMIs (along with interest payments, including revised interest rates / delayed charges, if applicable) henceforth. I further given my consent and hereby authorize Zypp and/or any of its group companies, where I am employed as on date (“Current Employer”) to deduct the EMI amount as specified by me from my monthly salary payout, which will be paid to the Financing Partner by Zypp and/or any of its group companies, till the time I am employed with the Current Employer or loan closure confirmation from me to the Current Employer, whichever is earlier, subject to applicable deductions and policies from time to time. I agree that personal loan repayment or EMI payment is always my responsibility and liability to repay all outstanding amounts to the Financing Partner on or within the stipulated dates, and Zypp and/or any of its group companies is not be made responsible / liable for any outstanding dues or any non-payment or any other charges payable by me to the Financing Partner, in case there is a delay or default in my loan repayment at any point of time. I further declare and undertake, that if at any stage, my employment with Company can be terminated /comes to an end, and loan will be refunded by me to Financing Partner directly. I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy. </p>",
    },
  ],
  smartstaff: [
    full_name_config,
    {
      ...company_employee_id_config,
      label: "SmartStaff ID number/आईडी नंबर:",
    },
    dob_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <li>On installing the SmartStaff application, providing my requisite details to SmartStaff, receiving a unique login ID and password, and agreeing to the terms of the Agreement for pick up and delivery partner, I had consented to provide services as a Pick-Up and Delivery Partner ('PDP') to customers or merchants on the SmartStaff platform (i.e website or mobile application operated by SmartStaff).</li>  <li>I am willing to participate in the 'Loan Program' being provided by Entitled Solutions Private Limited ('Entitled') through their NBFC partners..</li>  <li>For the aforesaid purpose, I authorize SmartStaff to share the following personal information with NBFC and Entitled: my name, phone number, address, date of engagement with SmartStaff, my ratings, my engagement status (active/inactive), bank account details, my gross earnings.</li> <li>I am agreeing that the instalments of the loan successfully disbursed to me will be deducted from my payout by SmartStaff and transferred to Entitled or it's NBFC partners.</li> <li>I understand and agree that SmartStaff will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to the loans availed by me.</li>    <li>I am agreeing to these terms and opting for the Loan Program voluntarily, by my own free will and volition.</li> <li> I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. </li> <li> I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy. </li> ",
    },
  ],
  chefkart: [
    full_name_config,
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <li>On installing the ChefKart application, providing my requisite details to ChefKart, receiving a unique login ID and password, and agreeing to the terms of the Agreement for chefs, I had consented to provide services to customers or merchants on the ChefKart platform (i.e website or mobile application operated by ChefKart).</li>  <li>I am willing to participate in the 'Loan Program' being provided by Entitled Solutions Private Limited ('Entitled') through their NBFC partners..</li>  <li>For the aforesaid purpose, I authorize ChefKart to share the following personal information with NBFC and Entitled: my name, phone number, address, date of engagement with ChefKart, my ratings, my engagement status (active/inactive), bank account details, my gross earnings.</li> <li>I am agreeing that the instalments of the loan successfully disbursed to me will be deducted from my payout by ChefKart and transferred to Entitled or it's NBFC partners.</li> <li>I understand and agree that ChefKart will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to the loans availed by me.</li>    <li>I am agreeing to these terms and opting for the Loan Program voluntarily, by my own free will and volition.</li> <li> I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. </li> <li> I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy. </li> ",
    },
  ],
  EverestFleet:[
    full_name_config,
    {
      ...company_employee_id_config,
      label: "Everest Fleet ID number/आईडी नंबर:",
    },
    dob_config,
    gender_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 100000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "1,00,000"
      ),
    },
    {
      ...loan_duration_config,
      validation: {
        ...loan_duration_config.validation,
        max: 12,
      },
      inputInfoText: "Limit of tenure is 12 months only"
    },
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <ol><li> I have been engaged with the “Company” as a full-time or contractual “Employee” or as an independent service provider as a “Gig Worker”.</li> <li> The “Company” has tied up with “Entitled Solutions Pvt Ltd” (hereinafter referred to as “Entitled”) to enable access to a “Loan Program”.</li> <li> “Entitled” is a benefits solution that enables access to loans (besides other services) for workers. It works with RBI registered NBFCs to process such loans for workers.</li> <li>I hereby confirm that I am willing to participate in the ‘Loan Program’ being provided by “Entitled”.</li><li> For the aforesaid purpose, I authorise the “Company” to deduct the instalments payable by me to “Entitled” for availing the loan facility provided by “Entitled”, from my pay-outs and remit the same to “Entitled” on my behalf.</li><li>I also authorise “Entitled” to charge instalments payable by me to “Entitled” for availing the loan facility provided by “Entitled”, to my bank account to which the “Company” deposits the salary or payout on a monthly or weekly basis via eNACH.</li><li> In addition to the same, I authorize the “Company” to share my personal information with “Entitled” including but not limited to my name, phone number, address, date of engagement with the “Company”, my status (active/inactive), bank account details, my gross earnings etc</li><li>I understand and agree that the “Company” will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to the loan availed by me.</li><li> I understand and agree that the “Company” will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to deductions from my payouts.</li>  <li> I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. </li> <li> I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy. </li> </ol>",
    },
  ],
  intrcity: [
    full_name_config,
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    gender_config,
    marital_status_config,
    date_of_joining_config,
    designation_config,
    bank_account_no_config,
    ifsc_config,
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <ol><li> I have been engaged with the “Company” as a full-time or contractual “Employee” or as an independent service provider as a “Gig Worker”.</li> <li> The “Company” has tied up with “Entitled Solutions Pvt Ltd” (hereinafter referred to as “Entitled”) to enable access to a “Loan Program”.</li> <li> “Entitled” is a benefits solution that enables access to loans (besides other services) for workers. It works with RBI registered NBFCs to process such loans for workers.</li> <li>I hereby confirm that I am willing to participate in the ‘Loan Program’ being provided by “Entitled”.</li><li> For the aforesaid purpose, I authorise the “Company” to deduct the instalments payable by me to “Entitled” for availing the loan facility provided by “Entitled”, from my pay-outs and remit the same to “Entitled” on my behalf.</li><li>I also authorise “Entitled” to charge instalments payable by me to “Entitled” for availing the loan facility provided by “Entitled”, to my bank account to which the “Company” deposits the salary or payout on a monthly or weekly basis via eNACH.</li><li> In addition to the same, I authorize the “Company” to share my personal information with “Entitled” including but not limited to my name, phone number, address, date of engagement with the “Company”, my status (active/inactive), bank account details, my gross earnings etc</li><li>I understand and agree that the “Company” will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to the loan availed by me.</li><li> I understand and agree that the “Company” will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to deductions from my payouts.</li>  <li> I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. </li> <li> I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy. </li> </ol>",
    },
  ],
  rydo: [
    full_name_config,
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    gender_config,
    marital_status_config,
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <ol><li> I have been engaged with the “Company” as a full-time or contractual “Employee” or as an independent service provider as a “Gig Worker”.</li> <li> The “Company” has tied up with “Entitled Solutions Pvt Ltd” (hereinafter referred to as “Entitled”) to enable access to a “Loan Program”.</li> <li> “Entitled” is a benefits solution that enables access to loans (besides other services) for workers. It works with RBI registered NBFCs to process such loans for workers.</li> <li>I hereby confirm that I am willing to participate in the ‘Loan Program’ being provided by “Entitled”.</li><li> For the aforesaid purpose, I authorise the “Company” to deduct the instalments payable by me to “Entitled” for availing the loan facility provided by “Entitled”, from my pay-outs and remit the same to “Entitled” on my behalf.</li><li>I also authorise “Entitled” to charge instalments payable by me to “Entitled” for availing the loan facility provided by “Entitled”, to my bank account to which the “Company” deposits the salary or payout on a monthly or weekly basis via eNACH.</li><li> In addition to the same, I authorize the “Company” to share my personal information with “Entitled” including but not limited to my name, phone number, address, date of engagement with the “Company”, my status (active/inactive), bank account details, my gross earnings etc</li><li>I understand and agree that the “Company” will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to the loan availed by me.</li><li> I understand and agree that the “Company” will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to deductions from my payouts.</li>  <li> I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. </li> <li> I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy. </li> </ol>",
    },
  ],
  eshram: [
    full_name_config,
    dob_config,
    aadhaar_mobile_number_config,
    gender_config,
    marital_status_config,
  ],
  logipe: [
    full_name_config,
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    gender_config,
    marital_status_config,
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <ol><li> I have been engaged with the “Company” as a full-time or contractual “Employee” or as an independent service provider as a “Gig Worker”.</li> <li> The “Company” has tied up with “Entitled Solutions Pvt Ltd” (hereinafter referred to as “Entitled”) to enable access to a “Loan Program”.</li> <li> “Entitled” is a benefits solution that enables access to loans (besides other services) for workers. It works with RBI registered NBFCs to process such loans for workers.</li> <li>I hereby confirm that I am willing to participate in the ‘Loan Program’ being provided by “Entitled”.</li><li> For the aforesaid purpose, I authorise the “Company” to deduct the instalments payable by me to “Entitled” for availing the loan facility provided by “Entitled”, from my pay-outs and remit the same to “Entitled” on my behalf.</li><li>I also authorise “Entitled” to charge instalments payable by me to “Entitled” for availing the loan facility provided by “Entitled”, to my bank account to which the “Company” deposits the salary or payout on a monthly or weekly basis via eNACH.</li><li> In addition to the same, I authorize the “Company” to share my personal information with “Entitled” including but not limited to my name, phone number, address, date of engagement with the “Company”, my status (active/inactive), bank account details, my gross earnings etc</li><li>I understand and agree that the “Company” will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to the loan availed by me.</li><li> I understand and agree that the “Company” will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to deductions from my payouts.</li>  <li> I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. </li> <li> I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy. </li> </ol>",
    },
  ],
  chaloNetwork:[
    mobile_number_config,
    full_name_config,
    {
      ...company_employee_id_config,
      label: "Chalo Network ID number/आईडी नंबर:",
    },
    dob_config,
    gender_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 100000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "1,00,000"
      ),
    },
    {
      ...loan_duration_config,
      validation: {
        ...loan_duration_config.validation,
        max: 12,
      },
      inputInfoText: "Limit of tenure is 12 months only"
    },
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <ol><li> I have been engaged with the “Company” as a full-time or contractual “Employee” or as an independent service provider as a “Gig Worker”.</li> <li> The “Company” has tied up with “Entitled Solutions Pvt Ltd” (hereinafter referred to as “Entitled”) to enable access to a “Loan Program”.</li> <li> “Entitled” is a benefits solution that enables access to loans (besides other services) for workers. It works with RBI registered NBFCs to process such loans for workers.</li> <li>I hereby confirm that I am willing to participate in the ‘Loan Program’ being provided by “Entitled”.</li><li> For the aforesaid purpose, I authorise the “Company” to deduct the instalments payable by me to “Entitled” for availing the loan facility provided by “Entitled”, from my pay-outs and remit the same to “Entitled” on my behalf.</li><li>I also authorise “Entitled” to charge instalments payable by me to “Entitled” for availing the loan facility provided by “Entitled”, to my bank account to which the “Company” deposits the salary or payout on a monthly or weekly basis via eNACH.</li><li> In addition to the same, I authorize the “Company” to share my personal information with “Entitled” including but not limited to my name, phone number, address, date of engagement with the “Company”, my status (active/inactive), bank account details, my gross earnings etc</li><li>I understand and agree that the “Company” will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to the loan availed by me.</li><li> I understand and agree that the “Company” will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to deductions from my payouts.</li>  <li> I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. </li> <li> I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy. </li> </ol>",
    },
  ],
  moove:[
    mobile_number_config,
    full_name_config,
    fathers_name_config,
    // {
    //   ...company_employee_id_config,
    //   label: "Moove ID number/आईडी नंबर:",
    // },
    {
      ...dob_config,
      label: "Date of Birth as per pan card/जन्मतिथि पैन कार्ड के अनुसार:",
    },
    gender_config,
    pan_card_config,
    adhaar_card_config,
    marital_status_config,
    // date_of_joining_config,
    perm_address_config,
    perm_address_pincode_config,
    curr_address_config,
    curr_address_pincode_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 35000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "35,000"
      ),
    },
    {
      ...deposit_amount_config,
      validation: {
        ...deposit_amount_config.validation,
        max: 35000,
      }
    },
    {
      ...loan_duration_config,
      validation: {
        ...loan_duration_config.validation,
        max: 6,
      },
      inputInfoText: "Limit of tenure is 6 months only"
    },
    repayment_config,
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <ol><li> I have been engaged with the “Company” as a full-time or contractual “Employee” or as an independent service provider as a “Gig Worker”.</li> <li> The “Company” has tied up with “Entitled Solutions Pvt Ltd” (hereinafter referred to as “Entitled”) to enable access to a “Loan Program”.</li> <li> “Entitled” is a benefits solution that enables access to loans (besides other services) for workers. It works with RBI registered NBFCs to process such loans for workers.</li> <li>I hereby confirm that I am willing to participate in the ‘Loan Program’ being provided by “Entitled”.</li><li> For the aforesaid purpose, I authorise the “Company” to deduct the instalments payable by me to “Entitled” for availing the loan facility provided by “Entitled”, from my pay-outs and remit the same to “Entitled” on my behalf.</li><li>I also authorise “Entitled” to charge instalments payable by me to “Entitled” for availing the loan facility provided by “Entitled”, to my bank account to which the “Company” deposits the salary or payout on a monthly or weekly basis via eNACH.</li><li> In addition to the same, I authorize the “Company” to share my personal information with “Entitled” including but not limited to my name, phone number, address, date of engagement with the “Company”, my status (active/inactive), bank account details, my gross earnings etc</li><li>I understand and agree that the “Company” will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to the loan availed by me.</li><li> I understand and agree that the “Company” will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to deductions from my payouts.</li>  <li> I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. </li> <li> I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy. </li> </ol>",
    },
  ],
};
